import React, { useState } from 'react';
import { FormGroup, FormControl, FormLabel, Form } from "react-bootstrap";
interface TextInputProps {
  value: string;
  controlID: string;
  label: string;
  onChange: () => void;
  autoFocus?: boolean;
  errorCondition?: boolean;
  errorMsg?: string;
  hintMsg?: string;
  maxLength?: number;
  className?: string;
  disabled?: boolean;
}

const TextInput: React.FC<TextInputProps> = (props) => {
  const {
    value,
    controlID,
    label,
    onChange,
    autoFocus=false,
    errorCondition=false,
    errorMsg="",
    hintMsg="",
    maxLength,
    className="",
  } = props;

  return (
    <div className="c-field__less-spacing">
      <input
        type="text"
        id={controlID}
        className={className ? className: "c-input"}
        placeholder={label}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        maxLength={maxLength}
      />
      {hintMsg && (
        <Form.Text>{hintMsg}</Form.Text>
      )}
      {errorCondition && (
        <Form.Text className="error-text">{errorMsg}</Form.Text>
      )}
    </div>
  )
}

export default TextInput;
